import React from 'react'
import ClickOutside from 'react-click-outside'
import CloseIcon from 'react-icons/lib/md/close'
import useEffect from '@hooks/useEffect'
import useKeyboardEvent from '@hooks/useKeyboardEvent'
import classnames from 'classnames'

import styles from './styles.module.css'

global.isModalOpen = false

export default function ModalInner(props) {
  const {contentClassName} = props
  useEffect(() => {
    global.isModalOpen = true
    return () => {
      global.isModalOpen = false
    }
  }, [])
  const close = e => {
    if (props.close) {
      props.close(e)
    }
  }

  useKeyboardEvent('Escape', close)

  return (
    <div className={styles.container}>
      <ClickOutside onClickOutside={close} className={styles.modalInner + ' ' + props.customClass}>
        <div className={styles.top}>
          <div className={styles.close}>
            <CloseIcon size="28" color="var(--primary-color)" onClick={close} />
          </div>
        </div>
        <div className={classnames(styles.content, contentClassName)}>{props.children}</div>
      </ClickOutside>
    </div>
  )
}
